import React from 'react';
import logo from '../../assets/img/logoFullWhite.png';
import { AppBar, Button, Toolbar } from '@mui/material';
import { useNavigate, Link } from 'react-router-dom';
import { logout } from '../../config';

export const Header = () => {
  const navigate = useNavigate();

  const buttonStyles = {
    border: '1px solid white',
    borderRadius: '50px',
    backgroundColor: '#fff',
    color: '#660033',
    transition: '.3s',
    '&:hover': {
      scale: '1.05',
      backgroundColor: '#fff',
      color: '#660033',
    },
  };

  return (
    <AppBar position='fixed' elevation={3} component='nav'>
      <Toolbar>
        <Button onClick={() => navigate('/landing')} style={{ width: '22%' }}>
          <a href='#about'>
            <img src={logo} alt='logo' width='170' height='55.01' />
          </a>
        </Button>
        {window.location.pathname.includes('landing') || window.location.pathname.includes('login')
          ? (
            <div className='nav'>
              <Button onClick={() => navigate('/landing')} style={{ width: '15%' }}>
                <a href='#about'>
                  À propos
                </a>
              </Button>
              <Button onClick={() => navigate('/landing')} style={{ width: '15%' }}>
                <a href='#solution'>
                  Nos Solutions
                </a>
              </Button>
              <Button onClick={() => navigate('/landing')} style={{ width: '15%' }}>
                <a href='#offer'>
                  Nos Offres
                </a>
              </Button>
              <Link to='/login' onClick={() => logout()}>
                <Button
                  sx={buttonStyles}>
                  Se connecter
                </Button>
              </Link>
            </div>
          )
          :
          (
            <div className='nav'>
              <Link to='/v1'>
                <Button>Détection par position</Button>
              </Link>
              <Link to='/v2'>
                <Button>Détection par carte</Button>
              </Link>
              <Link to='/login' onClick={() => logout()}>
                <Button>Se déconnecter</Button>
              </Link>
            </div>
          )
        }
      </Toolbar>
    </AppBar>
  );
};
